import type { DriveConfig, DriveConfigOnly } from '@app/types/config.types';

export const config: DriveConfigOnly & Partial<DriveConfig> = {
  file: {
    ndeType: 'application/data-nde',
    osetType: 'application/data-oset',
    odfType: 'application/data-odf',
    opdType: 'application/data-opd',
    odatType: 'application/data-odat',
  },
};
